import { Product } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import {
  zakelijkKozijnCodes,
  zakelijkProfielCodes,
} from "features/option-controls/door-width-controls/ZakelijkHelper";
import ProfielProductItemConfigTable from "./ProfielProductItemConfigTable";
import KozijnProductItemConfigTable from "./KozijnProductItemConfigTable";

interface ZakelijkDoorProductItemConfigTableProps {
  product: Product;
  className?: string;
}

const ZakelijkDoorProductItemConfigTable = ({
  product,
  className = "",
}: ZakelijkDoorProductItemConfigTableProps) => {
  if (zakelijkProfielCodes.includes(product.doorType.code)) {
    return <ProfielProductItemConfigTable product={product} />;
  }
  if (zakelijkKozijnCodes.includes(product.doorType.code)) {
    return <KozijnProductItemConfigTable product={product} />;
  }
  // Color name,price
  const doorColorName = product.doorColor.name;
  const doorColorPrice = "€" + (product.doorColor.price ?? 0).toFixed(2);

  // Handle name,price
  const doorHandleName = product.doorHandle.name;
  const doorHandlePrice = "€" + (product.doorHandle.price ?? 0).toFixed(2);

  // Glass name,price
  const doorGlassName = product.glassType.name;
  const doorGlassPrice = "€" + (product.glassType.price ?? 0).toFixed(2);

  //Extra options
  const doorExtraOptions = product.extraOptionsNames;
  // Extra options prices
  const doorExtraOptionsPrices = product.extraOptionsPrices;

  // Conditions to show extras
  const showDoorExtraOptionsPrices =
    doorExtraOptionsPrices && doorExtraOptionsPrices.length > 0;
  const showDoorExtraOptions = doorExtraOptions && doorExtraOptions.length > 0;
  return (
    <div className={`gg-mt-3 gg-pr-5 gg-text-sm lg:gg-mt-0.5 ${className}`}>
      <section className="gg-grid gg-w-full gg-gap-y-1 sm:gg-gap-y-1.5 md:gg-gap-y-2">
        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Frame
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorColorName}&nbsp;
            <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
              ({doorColorPrice})
            </span>
          </Text>
        </div>

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Glas
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorGlassName} &nbsp;
            <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
              ({doorGlassPrice})
            </span>
          </Text>
        </div>

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Deurbeslag
          </Heading>
          <Text className="gg-whitespace-nowrap gg-text-right lg:gg-text-start">
            {doorHandleName}&nbsp;
            <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
              ({doorHandlePrice})
            </span>
          </Text>
        </div>

        {showDoorExtraOptions && (
          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Extra opties
            </Heading>
            <ul className="gg-space-y-1 gg-text-right lg:gg-text-start">
              {doorExtraOptions.map((name, index) => (
                <li key={name}>
                  <Text>
                    {name}&nbsp;
                    <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
                      (
                      {showDoorExtraOptionsPrices &&
                        "€" + doorExtraOptionsPrices[index].toFixed(2)}
                      )
                    </span>
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>
    </div>
  );
};
export default ZakelijkDoorProductItemConfigTable;
